<template>
  <div>
    <div>
      <p class="bold">חלון מספר 2 מתוך 3</p>
    </div>
    <position-form-links style="text-align: center;" :position_id="payload.position.id" :company_id="payload.company_id"></position-form-links>
    <div>
      <p style="font-size: 30px;"><b>{{payload.position.title}} (Position ID: {{payload.position.id}})</b></p>
      <div>
        <p><b>Abstract</b></p>
        <textarea
          v-model="abstract"
          class="full_width"
          :class="{ error_border: abstract_error }"
          placeholder="סיכום על המשרה שלא מוצג למשתמשים או לחברות, אלא לשימוש פנימי">
        </textarea>
      </div>
      <div>
        <p><b>Salary Expectations</b></p>
        <input v-model="salary_expectations" :class="{ error_border: salary_expectations_error }" class="outlined full_width">
      </div>
      <div>
        <p><b>Contact Email</b></p>
        <input v-model="contact_email" :class="{ error_border: contact_email_error }" class="outlined full_width" placeholder="leahgoldberg@herzog.co.il">
      </div>
      <div>
        <p><b>Position Company ID (Internal)</b></p>
        <input v-model="company_position_id" :class="{ error_border: company_position_id_error }" class="outlined full_width">
      </div>
      <div>
        <p><b>Work Entails *</b></p>
        <div class="is-flex is-flex-direction-column">
          <div :class="{ error_border: work_entails_error }" v-for="(work_entail, index) in work_entails" :key="'work-entail-' + index">
            <input v-model="work_entails[index]" class="outlined full_width">
            <div style="height: 10px;"></div>
          </div>
        </div>
      </div>
      <div>
        <p><b>Internal Notes</b></p>
        <textarea :class="{ error_border: internal_notes_error }" v-model="internal_notes" placeholder="..." class="full_width"></textarea>
      </div>
    </div>
    <div class="modal_footer" style="justify-content: space-between;">
      <a
        @click="continueToStepThree()"
        :class="{ 'is-loading': is_loading }"
        class="button is-info"
        >סיום</a
      >
      <p><b>שלב שני</b></p>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import PositionFormLinks from '@/components/PositionFormLinks'
import TextsHelper from '@/custom/classes/texts_helper.js'
export default {
  name: 'create-position-step-two',
  props: ['payload'],
  data () {
    return {
      texts_helper: new TextsHelper(),
      is_loading: false,
      abstract: '',
      contact_email: '',
      company_position_id: '',
      salary_expectations: '',
      internal_notes: '',
      work_entails: ['', '', '', '', ''],
      abstract_error: false,
      contact_email_error: false,
      company_position_id_error: false,
      salary_expectations_error: false,
      work_entails_error: false,
      internal_notes_error: false
    }
  },
  methods: {
    continueToStepThree () {
      let work_entails = this.work_entails.filter(work_entail => work_entail.length > 0).join('@@@')
      let internal_notes_content = this.texts_helper.getBoldContent(this.internal_notes, 'internal_notes')
      let abstract_content = this.texts_helper.getBoldContent(this.abstract, 'abstract')
      if (work_entails.length == 0) {
        this.$utils.emit('show_toast', { text: 'work_entails ריק' })
        return
      }
      if (internal_notes_content == 'problem') {
        return
      }
      if (abstract_content == 'problem') {
        return
      }
      this.is_loading = true
      let requests = []
      if (this.abstract.length > 0) {
        requests.push(this.$network_utils.postText({ designator: 'abstract', content: abstract_content, current_type: 'Position', current_resource_id: this.payload.position.id })
          .catch(() => {
            this.abstract_error = true
          }))
      }
      if (this.contact_email.length > 0) {
        requests.push(this.$network_utils.postText({ designator: 'contact_email', content: this.contact_email, current_type: 'Position', current_resource_id: this.payload.position.id })
          .catch(() => {
            this.contact_email_error = true
          }))
      }
      if (this.company_position_id.length > 0) {
        requests.push(this.$network_utils.updatePosition({ position_id: this.payload.position.id, company_position_id: this.company_position_id }).catch(() => {
          this.company_position_id_error = true
        }))
      }
      if (this.salary_expectations.length > 0) {
        requests.push(this.$network_utils.postText({ designator: 'salary_expectations', content: this.salary_expectations, current_type: 'Position', current_resource_id: this.payload.position.id })
          .catch(() => {
            this.salary_expectations_error = true
          }))
      }
      requests.push(this.$network_utils.postText({ designator: 'work_entails', content: work_entails, current_type: 'Position', current_resource_id: this.payload.position.id })
        .catch(() => {
          this.work_entails_error = true
        }))
      requests.push(this.$network_utils.postStat({ title: 'new internal note', designator: 'internal_notes', content: this.internal_notes, resource_type: 'Position', resource_id: this.payload.position.id, owner: this.owner, priority: 5 })
        .catch(() => {
          this.internal_notes_error = true
        }))
      this.$caller.axios.all(requests).then(responses => {
        this.is_loading = false
        if (responses.includes(undefined)) {
          return
        }
        this.payload.is_fixed = false
        this.remove(this.payload)
        this.create({
          designator: 'create-position-step-three',
          component_name: 'CreatePositionStepThree',
          ignore_escape_button: true,
          modal_width: 900,
          position: this.payload.position,
          company_id: this.payload.company_id,
          modal_title: 'Create new Position'
        })
      })
    },
    ...mapMutations('modals', ['remove', 'create'])
  },
  components: {
    PositionFormLinks
  }
}
</script>
<style>
  .error_border{
    border-color: red !important;
  }
</style>
